import { render } from "./UkWorkStep.vue?vue&type=template&id=38683ff6"
import script from "./UkWorkStep.vue?vue&type=script&lang=js"
export * from "./UkWorkStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__